/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * A schema for a linked credential value in a Credential claim.
 */
export interface CredentialClaimLinkedCredentialValue {
    /** The multibase digest of the linked credential. */
    digestMultibase?: string;
    /** The ID of the linked credential. */
    id: string;
}
